import React from "react";
import { motion } from "framer-motion";
import { PenTool, Printer, Truck } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Design",
    icon: PenTool,
    body:
      "Share your logo, idea, or a rough sketch on WhatsApp. Our team mocks it up in 24 hours with real fabric previews.",
    bg: "#FFE600",
  },
  {
    n: "02",
    title: "Print",
    icon: Printer,
    body:
      "Sublimation, screen or DTF — we pick the right method for your fabric, colour count and quantity.",
    bg: "#FF0055",
    fg: "#FFFFFF",
  },
  {
    n: "03",
    title: "Deliver",
    icon: Truck,
    body:
      "Quality-checked, neatly packed and shipped across India. Rush orders? We've got you — just ask.",
    bg: "#00F0FF",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="border-b-4 border-black py-20 lg:py-28 bg-[#F0F0F0]"
      data-testid="process-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="mb-12 lg:mb-16 max-w-3xl">
          <div className="font-heading uppercase text-xs tracking-[0.3em] text-[#555] mb-4">
            /// How we work
          </div>
          <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            From brief to box
            <br />
            in <span className="bg-black text-[#FFE600] px-2 inline-block">three steps.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative nb-border-4 nb-shadow p-6 md:p-8 bg-white"
                data-testid={`process-step-${i}`}
              >
                <div
                  className="absolute -top-5 -left-5 w-16 h-16 nb-border-4 flex items-center justify-center font-heading text-2xl"
                  style={{ background: s.bg, color: s.fg || "#0A0A0A" }}
                >
                  {s.n}
                </div>
                <div className="flex items-center justify-end">
                  <Icon size={36} strokeWidth={2.5} className="text-[#0A0A0A]" />
                </div>
                <h3 className="mt-6 font-heading uppercase text-3xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-[#0A0A0A]/80">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
